import Login from 'core/views/Login.vue'
import LoginEmpresa from 'core/views/LoginEmpresa.vue'
import Lembrar from 'core/views/Lembrar.vue'
import Alterar from 'core/views/Alterar.vue'
export default [
  {
    title: 'Lista de Simulações',
    icon: 'ph-calculator-light',
    path: '/simulacao',
    menu: true,
    dir: 'views/simulador/',
    view: 'Simulacao',
    meta: {
      requiresAuth: true,
      roles: ['Multiplo.Gerente', 'Multiplo.Operador', 'Multiplo.Backoffice', 'Multiplo.Master']
    }
  },
  {
    title: 'Simular Proposta',
    icon: 'ph-file-plus-light',
    path: '/simulacao-edit',
    menu: true,
    dir: 'views/simulador/',
    view: 'SimulacaoEdit',
    meta: {
      requiresAuth: true,
      roles: ['Multiplo.Gerente', 'Multiplo.Operador', 'Multiplo.Backoffice', 'Multiplo.Master']
    }
  },
  {
    title: 'Propostas',
    path: '/propostas',
    menu: false,
    dir: 'views/proposta/',
    view: 'PropostaEdit',
    meta: {
      requiresAuth: true,
      roles: ['Multiplo.Gerente', 'Multiplo.Operador', 'Multiplo.Backoffice', 'Multiplo.Master']
    }
  },
  {
    title: 'Lista Propostas',
    icon: 'ph-list-checks',
    path: '/proposta-list',
    menu: true,
    home: true,
    dir: 'views/proposta/',
    view: 'Proposta',
    meta: {
      requiresAuth: true,
      roles: ['Multiplo.Gerente', 'Multiplo.Operador', 'Multiplo.Backoffice', 'Multiplo.Master']
    }
  },
  {
    title: 'Base de Consultas',
    icon: 'ph-hard-drives',
    path: '/base-consultas',
    menu: true,
    home: true,
    dir: 'views/base-consultas/',
    view: 'BaseConsulta',
    meta: {
      requiresAuth: true,
      roles: ['Multiplo.Gerente', 'Multiplo.Operador', 'Multiplo.Backoffice', 'Multiplo.Master']
    }
  },
  {
    title: 'Acesso Cliente',
    path: '/proposta-cliente',
    menu: false,
    home: true,
    dir: 'views/proposta-cliente/',
    view: 'PropostaCliente',
    meta: {
      requiresAuth: true,
      roles: ['Multiplo.AcessoExterno']
    }
  },
  {
    path: '/',
    component: Login,
    title: 'Login',
    menu: false,
    meta: {
      anonymousAuth: true
    }
  },
  {
    path: '/lembrar',
    component: Lembrar,
    default: true,
    title: 'Lembrar Senha',
    menu: false,
    meta: {
      anonymousAuth: true
    }
  },
  {
    path: '/recuperar',
    component: Alterar,
    default: true,
    title: 'Alterar Senha',
    menu: false,
    meta: {
      anonymousAuth: true
    }
  },
  {
    path: '/parceiro',
    component: LoginEmpresa,
    title: 'Login Empresa',
    menu: false,
    meta: {
      anonymousAuth: true
    }
  }
]
